<template>
  <div class="container">
    <div class="logo-container">
      <img src="../../../assets/images/logo-2.png" alt="" @click="goHome"/>
    </div>

    <div class="action-container">
      <a-space>
        <a-button type="dashed" icon="copy" @click="copyAll" ghost>复制全部</a-button>
        <a-button type="dashed" icon="copy" @click="copyNew" ghost>复制最新</a-button>
      </a-space>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      
    }
  },
  computed:{
    ...mapState('queryResult',['recordList'])
  },
  methods:{
    //复制全部
    copyAll() {
      if(this.recordList.length === 0) return this.$message.warning('当前没有任何可复制的记录')
      //遍历获得
      let arr = this.recordList
      let str = ''

      arr.forEach((item) => {
        str += `===========================START=========================\n`
        str += `单号:${item.code}\n`
        str += `时间:${item.datetime}\n`
        str += `目的地:${item.destination}\n`
        str += `城市:${item.position}\n`
        str += `状态:${item.status_str}\n`
        str += `备注:${item.note}\n`
        item.detail_list.forEach((item2) => {
          str += `单号:${item.code}\t时间:${item.datetime}\t目的地:${item.destination}\t城市:${item.position}\t状态:${item.status_str}\t备注:${item.note}\n`
        })
        str += `===========================END===========================\n\n\n`
      })

      this.$copyText(str).then(
        (res) => {
          this.$message.success('复制全部订单成功')
        },
        () => {
          this.$message.error('复制全部订单失败')
        }
      )
    },

    //复制最新
    copyNew() {
      if(this.recordList.length === 0) return this.$message.warning('当前没有任何可复制的记录')
      //遍历获得
      let arr = this.recordList
      let str = ''

      arr.forEach((item) => {
        str += `===========================START=========================\n`
        str += `单号:${item.code}\n`
        str += `时间:${item.datetime}\n`
        str += `目的地:${item.destination}\n`
        str += `城市:${item.position}\n`
        str += `状态:${item.status_str}\n`
        str += `备注:${item.note}\n`
        str += `===========================END===========================\n\n\n`
      })

      this.$copyText(str).then(
        (res) => {
          this.$message.success('复制全部订单最新状态成功')
        },
        () => {
          this.$message.error('复制全部订单最新状态失败')
        }
      )
    },
    
    // 点击logo跳转到首页
    goHome(){
      this.$router.push('/home')
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo-container {
    margin-top: -12px;
    width: 200px;
    img {
      cursor: pointer;
      width: 100%;
    }
  }
}
</style>